import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/app.css";
import "@/core/billing/act-completion-billing";
import "@/core/billing/extended-hospital-billing";
import "@/core/insurance/hub-coverage-sync";
import { HospitolProviders } from "./providers/HospitolProviders";
import { AppRouter } from "./router/router";
import { AppErrorBoundary } from "./components/AppErrorBoundary";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppErrorBoundary title="ITaaS Hospitol — erreur de chargement">
      <HospitolProviders>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </HospitolProviders>
    </AppErrorBoundary>
  </StrictMode>,
);
